export function minutesOfDay(time) {
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time || "")) return null;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
}

export function formatAssistanceMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return hours ? `${hours} h${rest ? ` ${rest} min` : ""}` : `${rest} min`;
}

function coveredMinutes(intervals) {
  let end = -1;
  let total = 0;
  for (const [start, stop] of [...intervals].sort((a, b) => a[0] - b[0])) {
    total += Math.max(0, stop - Math.max(start, end));
    end = Math.max(end, stop);
  }
  return total;
}

export function summarizeAssistanceTime(startTime, endTime, entries) {
  const start = minutesOfDay(startTime);
  const end = minutesOfDay(endTime);
  if (start === null || end === null || end <= start) return null;
  const scheduled = [];
  let outside = false;
  for (const entry of entries) {
    const from = minutesOfDay(entry.startTime);
    const to = minutesOfDay(entry.endTime);
    if (from === null || to === null || to <= from) continue;
    if (from < start || to > end) outside = true;
    scheduled.push([from, to]);
  }
  const booked = scheduled.reduce((sum, [from, to]) => sum + to - from, 0);
  return {
    total: end - start, booked,
    remaining: Math.max(0, end - start - booked), exceeded: Math.max(0, booked - (end - start)), outside,
    overlap: booked - coveredMinutes(scheduled),
  };
}
